import {
  faCircleInfo,
  faCloudArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useRef } from "react";
import { GrigoraEditorContext } from "../context";
import { IconsRenderer } from "../../../assets/icon-pack";
import { Tooltip } from "react-tooltip";
import { WEBCLIP_URL } from "../../app";
import { WhiteLabelContext } from "../../whitelabel";

function SettingsIcons() {
  const {
    project,
    projectID,
    updateProjectFavicon,
    updateProjectSitelogo,
    updateProjectWebclip,
  } = useContext(GrigoraEditorContext);

  const { __whitelabel__ } = useContext(WhiteLabelContext) ?? {};

  const sitelogoRef = useRef();
  const faviconRef = useRef();
  const touchRef = useRef();

  const uploadFaviconFile = (e) => {
    e.preventDefault();
    faviconRef.current.click();
  };

  const handleFaviconUpload = (e) => {
    if (e.target.files[0]) {
      updateProjectFavicon(e.target.files[0])
        .then((newFavicon) => {})
        .catch((err) => {});
    }
  };

  const uploadSitelogoFile = (e) => {
    e.preventDefault();
    sitelogoRef.current.click();
  };

  const handleSitelogoUpload = (e) => {
    if (e.target.files[0]) {
      updateProjectSitelogo(e.target.files[0])
        .then((newSitelogo) => {})
        .catch((err) => {});
    }
  };

  const uploadTouchFile = (e) => {
    e.preventDefault();
    touchRef.current.click();
  };

  const handleWebclipUpload = (e) => {
    if (e.target.files[0]) {
      updateProjectWebclip(e.target.files[0])
        .then((newWebclip) => {})
        .catch((err) => {});
    }
  };

  return (
    <>
      <div className="icon-setting-container flex flex-col gap-[20px] p-5 cursor-default overflow-x-hidden h-full overflow-y-auto">
        <div className="flex gap-[10px] items-center">
          <div className="flex items-center justify-center w-[70px] h-[70px] aspect-square	rounded-[5px] border border-dashed border-gray-400 p-2">
            {project.sitelogo ? (
              <>
                <img
                  className="h-full w-auto"
                  src={`https://cdn.grigora.co/projects/${projectID}/${project.sitelogo}`}
                />
              </>
            ) : (
              <>
                <img
                  className="h-full w-auto"
                  src={__whitelabel__("icon", WEBCLIP_URL)}
                />
              </>
            )}
          </div>
          <div className="flex flex-col gap-[7px]">
            <input
              type="file"
              id="sitelogofile"
              className="hidden"
              ref={sitelogoRef}
              onChange={handleSitelogoUpload}
              accept="image/jpeg,image/png,image/webp"
            />
            <h2 className="mb-1 text-md">Site Logo</h2>
            <button
              onClick={uploadSitelogoFile}
              className="grigora-action-btn w-20 h-7 flex items-center justify-center gap-1 !p-2 "
            >
              <FontAwesomeIcon size="sm" icon={faCloudArrowUp} />{" "}
              <span className="text-xs">Upload</span>
            </button>
            <span className="text-grigora-base rounded"></span>
          </div>
        </div>
        <div className="flex gap-[10px] items-center justify-between ">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-[70px] h-[70px] aspect-square	rounded-[5px] border border-dashed border-gray-400 p-2">
              {project.favicon ? (
                <>
                  <img
                    className="h-full w-auto"
                    src={`https://cdn.grigora.co/projects/${projectID}/${project.favicon}`}
                  />
                </>
              ) : (
                <>
                  <img
                    className="h-full w-auto"
                    src={`https://cdn.grigora.co/defaults/img/favicon.ico`}
                  />
                </>
              )}
            </div>

            <div className="flex flex-col gap-[7px]">
              <input
                type="file"
                id="faviconfile"
                className="hidden"
                ref={faviconRef}
                onChange={handleFaviconUpload}
                accept="image/jpeg,image/png,image/webp"
              />
              <h2 className="mb-1 text-md">Favicon</h2>
              <button
                onClick={uploadFaviconFile}
                className="grigora-action-btn w-20 h-7 flex items-center justify-center gap-1 !p-2 "
              >
                <FontAwesomeIcon size="sm" icon={faCloudArrowUp} />{" "}
                <span className="text-xs">Upload</span>
              </button>
            </div>
          </div>
          <IconsRenderer
            id={`favicon-info-btn`}
            name="Info"
            icon={faCircleInfo}
            className="cursor-pointer w-[17px] h-[17px] self-start outline-none"
          />
          <Tooltip
            style={{ pointerEvents: "auto" }}
            id={`favicon-info-btn`}
            className="!opacity-100 !bg-white !text-black !border-[1px] !text-xs !w-44 !rounded-[21px] !absolute p-3"
            anchorSelect={`#favicon-info-btn`}
          >
            Please upload a square shape image. The image will eventually be
            scaled to 32x32px resolution.
          </Tooltip>
        </div>

        <div className="flex gap-[10px] items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-[70px] h-[70px] aspect-square	rounded-[5px] border border-dashed border-gray-400 p-2">
              {project.webclip ? (
                <>
                  <img
                    className="h-full w-auto"
                    src={`https://cdn.grigora.co/projects/${projectID}/${project.webclip}`}
                  />
                </>
              ) : (
                <>
                  <img
                    className="h-full w-auto"
                    src={__whitelabel__("icon", WEBCLIP_URL)}
                  />
                </>
              )}
            </div>
            <div className="flex flex-col gap-[7px]">
              <input
                type="file"
                id="faviconfile"
                className="hidden"
                ref={touchRef}
                onChange={handleWebclipUpload}
                accept="image/jpeg,image/png,image/webp"
              />
              <h2 className="mb-1 text-md">Apple Touch Icon</h2>
              <button
                onClick={uploadTouchFile}
                className="grigora-action-btn w-20 h-7 flex items-center justify-center gap-1 !p-2 "
              >
                <FontAwesomeIcon size="sm" icon={faCloudArrowUp} />{" "}
                <span className="text-xs">Upload</span>
              </button>
            </div>
          </div>
          <IconsRenderer
            id={`apple-touch-icon-info-btn`}
            name="Info"
            icon={faCircleInfo}
            className="cursor-pointer w-[17px] h-[17px] self-start outline-none"
          />
          <Tooltip
            style={{ pointerEvents: "auto" }}
            id={`apple-touch-icon-info-btn`}
            className="!opacity-100 !bg-white !text-black !border-[1px] !text-xs !w-44 !rounded-[21px] !absolute p-3"
            anchorSelect={`#apple-touch-icon-info-btn`}
          >
            Please upload a square shape image. The image will eventually be
            scaled to 256x256px resolution.
          </Tooltip>
        </div>
      </div>
    </>
  );
}

export default SettingsIcons;
